import requests from "./httpService";

const AttendanceServices = {
    checkIn: async (data) =>
        requests.post("/attendance/checkIn", data),

    checkOut: async (data) =>
        requests.post("/attendance/checkOut", data),

    desileFillUp: async (data) =>
        requests.post("/attendance/desilefileUp", data),

    updateVehicle: async (id, body) =>
        requests.put(`/vehicle/${id}`, body),

    addVehicle: async (body) =>
        requests.post("/vehicle", body),

    deleteVehicle: async (id) =>
        requests.delete(`/vehicle/${id}`),

    getAttendaceByDriveId: async (id) =>
        requests.get(`/attendance/driver/${id}`),

    myAttendance: async () =>
        requests.get("/attendance/my/attendance"),

    getAttendanceByStatus: async (status, approvalStatus) =>
        requests.get("/attendance/status", {
            params: {
                status,
                approvalStatus
            }
        }),

    getPendingReviews: async () =>
        requests.get("/attendance/status", {
            params: {
                status: "checkOut",
                pendingReview: true
            }
        }),

    updateAttendance: async (id, body) =>
        requests.put(`/attendance/${id}`, body),

    updateReviewDetails: async (id, body) =>
        requests.patch(`/attendance/${id}/review-details`, body),

    approveAttendance: async (attendanceId, expectedVersion) =>
        requests.patch("/attendance/approve", {
            attendanceId,
            expectedVersion
        }),

    rejectAttendance: async (
        attendanceId,
        remark,
        expectedVersion
    ) =>
        requests.patch("/attendance/reject", {
            attendanceId,
            remark,
            expectedVersion
        }),

    approveDiesel: async (attendanceId, expectedVersion) =>
        requests.patch("/attendance/diesel/approve", {
            attendanceId,
            expectedVersion
        }),

    rejectDiesel: async (
        attendanceId,
        remark,
        expectedVersion
    ) =>
        requests.patch("/attendance/diesel/reject", {
            attendanceId,
            remark,
            expectedVersion
        }),

    attendenceReport: async (body) =>
        requests.post("/attendance/report", body),

    pdfReport: async (body) =>
        requests.post("/attendance/pdfreport", body)
};

export default AttendanceServices;